import i18next from 'i18next';

var ERROR = 'error';
var INFO = 'info';
var SUCCESS = 'success';
var WARNING = 'warning';
var SEARCH_TYPE_PATTERNS = {
  DUNS: {
    pattern: /^\d{9}$/,
    msg: "infos.duns"
  },
  SIRET: {
    pattern: /^\d{14}$/,
    msg: "infos.localId"
  },
  SIREN: {
    pattern: /^\d{9}$/,
    msg: "infos.localId"
  },
  VAT: {
    pattern: /^[A-Za-z]{2}[A-Za-z0-9]+$/,
    msg: "infos.vat"
  },
  VAT_FR: {
    pattern: /^(FR)[0-9]{11}$/,
    msg: "infos.vat"
  }
};
var DATA_TABLE_ACTIONS = {
  VIEW: {
    label: "view",
    icon: "modify-action",
    tooltip: "show",
    tooltipDisabled: "showDisabled"
  },
  ANSWER: {
    label: "answer",
    icon: "answer",
    tooltip: "answer",
    tooltipDisabled: "answerDisabled"
  },
  UPDATE_ANSWER: {
    label: "answerUpdate",
    icon: "answer_blue",
    tooltip: "answerUpdate",
    tooltipDisabled: "answerUpdateDisabled"
  }
};
var DocumentFormDataType = {
  IBAN: 'iban',
  AMOUNT: 'amount',
  NUMBER: 'number',
  DECIMAL: 'decimal',
  PHONE: 'phone',
  EMAIL: 'email',
  DATE: 'date',
  TEXT: 'text',
  STRING: 'string',
  CHOICES: 'choices',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  UNKNOWN: 'unknown'
};
var AttributeType = {
  DATE: "date",
  LIST_MULTIPLE: "list_multiple",
  LIST_UNIQUE: "list_unique",
  DECIMAL: "decimal",
  INTEGER: "integer",
  PERCENTAGE: "percentage",
  STRING: "string",
  BOOLEAN: "boolean"
};
var ATTRIBUTE_MAX_LABEL_LENGTH = 100;
var ATTRIBUTE_MAX_LIST_VALUE_LENGTH = 100;
var ATTRIBUTE_MAX_TEXT_VALUE_LENGTH = 255;
var ATTRIBUTE_VALUES_MIN_SIZE = 2;
var AI_EXTRACTED_DATA_KEYS = ['siren', 'type', 'denomination_sociale', 'adresse', 'date_delivrance'];
var BANK_DATA_KEYS = ['bank_data_bank', 'bank_data_bic', 'bank_data_address', 'bank_data_zip', 'bank_data_city', 'bank_data_country_iso', 'bank_data_phone', 'bank_data_fax', 'bank_data_email', 'bank_data_www', 'sepa_data_sct', 'sepa_data_sdd', 'sepa_data_cor1', 'sepa_data_b2b', 'sepa_data_scc'];

// eslint-disable-next-line
var REGEXP_EMAIL = /^(?:[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var REGEXP_NAME = /^([a-zA-ZàáâãäåæçèéêëìíîïñòóôõöùúûüýÿÀÁÂÃÄÅÇÈÉÊËÌÍÎÏÑÒÓÔÕÖÙÚÛÜÝ'ß'\-\s])+$/i;
var REGEXP_PASSWORD = new RegExp("(?:(?=.*\\d)(?=.*[A-ZÀ-Ÿ])(?=.*[a-zà-ÿ])|(?=.*\\d)(?=.*[^A-ZÀ-Ÿa-zà-ÿ0-9])(?=.*[a-zà-ÿ])|(?=.*[^A-ZÀ-Ÿa-zà-ÿ0-9])(?=.*[A-ZÀ-Ÿ])(?=.*[a-zà-ÿ])|(?=.*\\d)(?=.*[A-ZÀ-Ÿ])(?=.*[^A-ZÀ-Ÿa-zà-ÿ0-9]))(?!.*(.)\\1{2,})[A-ZÀ-Ÿa-zà-ÿ0-9!~<>,;:_=?*+#.\"&§%°()\\|\\[\\]\\-\\$\\^\\@\\/]{10,128}");
var REGEXP_INTEGER = /^[+-]?\d+$/i;
var REGEXP_DECIMAL = /^[+-]?\d+([.,]?\d+)?$/i;
var REGEXP_PERCENTAGE = /^[+-]?\d+([.,]?\d+)?%$/i;
var REGEXP_SEMICOLON = /[;]+/i;
var REGEXP_DOSSIER_MODEL_CODE = /^[A-Z_]+$/;
var FREE = "FREE";
var DefaultSelectProps = {
  MenuProps: {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    style: {
      zIndex: 1301
    }
  }
};
var Subscription = {
  SIS_ID: "SISID",
  TRUSTPAIR: "TRUSTPAIR",
  INDUED: "INDUED",
  TRANSPARENCY: "TRANSPARENCY",
  DATABLOCKS_FINANCIAL_STRENGTH: "FINANCIALSTRENGTH",
  OWLIN: "OWLIN",
  DATABLOCKS_ESG: "ESG",
  ECOVADIS: "ECOVADIS",
  DATA_HUB: "DATA_HUB",
  SECURITY_RATING: "SECURITY_RATING",
  CREDITSAFE: "CREDITSAFE"
};
var SubscriptionsControls = Object.freeze({
  SIS_ID: "sis_id",
  TRUSTPAIR: "trustpair",
  INDUED: "indued",
  ECOVADIS: "ecovadis"
});

//TODO: use subscription instead of these ?!
var SIS_ID = "sis_id";
var TRUSTPAIR = "trustpair";
var INDUED = "indued";
var EDGE_DATE_FORMAT = "YYYY-MM-DD";
var statusEngCode = {
  NOT_VALID: "NOT_VALID",
  VALID: "VALID",
  BELOW_EXPECTATION: "BELOW_EXPECTATION",
  MISSING: "MISSING",
  IN_PROGRESS: "IN_PROGRESS",
  ACTION_REQUIRED: "ACTION_REQUIRED",
  INCONNU: "INCONNU"
};
var AcquisitionChannel = Object.freeze({
  FO: "FO",
  DO: "DO",
  DO_FO: "DO_FO",
  PLATFORM: "PLATFORM"
});
var ThirdpartyAdditionalFieldsNames = Object.freeze({
  SCORES: "scores",
  ATTRIBUTES: "attributes",
  CALCULATED_ATTRIBUTES: "calculatedAttributes",
  INDICATORS: "indicators"
});
var ThirdpartyScoresFieldsNames = Object.freeze({
  INDUED: "indued",
  TRANSPARENCY: "transparency",
  FINANCIAL_STRENGTH_SCORE: "financialStrengthScore",
  FINANCIAL_STRENGTH_RATING: "financialStrengthRating",
  ESG_SCORE: "esgScore",
  ESG_DEPTH: "esgDepth",
  ESG_RISK_ENVIRONMENTAL: "esgRiskEnvironment",
  ESG_RISK_SOCIAL: "esgRiskSocial",
  ESG_RISK_GOVERNANCE: "esgRiskGovernance"
});
var DossiersAdditionalFieldsNames = Object.freeze({
  ATTRIBUTES: "attributes"
});
var DOMTOMList = ["GP", "MQ", "GF", "YT", "RE", "BL", "MF", "PM", "WF", "NC", "PF"];
var preferredCountries = ["fr", "de", "it", "gb", "es", "be", "nl", "ch", "lu", "pt", "us", "cn"];
var FieldType = {
  TEXT: "TEXT",
  NUMERIC: "NUMERIC",
  DATE: "DATE",
  BOOLEAN: "BOOLEAN",
  CUSTOM: "CUSTOM",
  ATTRIBUTE: "ATTRIBUTE",
  RISK: "RISK",
  CALCULATED_ATTRIBUTE: "CALCULATED_ATTRIBUTE",
  INDICATOR: "INDICATOR",
  SOURCE_VARIABLE: "SOURCE_VARIABLE",
  FORM_FIELD: "FORM_FIELD",
  ACTIVITY: "ACTIVITY",
  SOURCE_DATA: "SOURCE_DATA",
  CONTEXT_RANK: "CONTEXT_RANK"
};
var FieldDisplayVariant = {
  STANDARD: "STANDARD",
  AUTOCOMPLETE: "AUTOCOMPLETE"
};
var Operator = {
  EQUAL: "EQUAL",
  NOT_EQUAL: "NOT_EQUAL",
  GREATER_THAN: "GREATER_THAN",
  GREATER_OR_EQUAL: "GREATER_OR_EQUAL",
  LESS_THAN: "LESS_THAN",
  LESS_OR_EQUAL: "LESS_OR_EQUAL",
  BETWEEN: "BETWEEN",
  IS_NULL: "IS_NULL",
  NOT_NULL: "NOT_NULL",
  CONTAINS: "CONTAINS",
  NOT_CONTAINS: "NOT_CONTAINS",
  STARTS_WITH: "STARTS_WITH",
  NOT_STARTS_WITH: "NOT_STARTS_WITH",
  ENDS_WITH: "ENDS_WITH",
  NOT_ENDS_WITH: "NOT_ENDS_WITH",
  IN_SET: "IN_SET",
  NOT_IN_SET: "NOT_IN_SET"
};
var Exports = {
  CSV: "CSV",
  XLS: "XLS",
  XLSX: "XLSX"
};
var ActivityLevel = {
  SIC_MAJOR: 1,
  SIC_2_DIGITS: 2,
  SIC_3_DIGITS: 3,
  SIC_4_DIGITS: 4,
  SIC_6_DIGITS: 6,
  SIC_8_DIGITS: 8
};
var ThirdpartyScoreType = {
  INDUED: "INDUED",
  DATABLOCKS_FINANCIAL_STRENGTH: "DATABLOCKS_FINANCIAL_STRENGTH",
  DATABLOCKS_ESG: "DATABLOCKS_ESG",
  ECOVADIS: "ECOVADIS",
  SECURITY_RATING: "SECURITY_RATING"
};
var KEYCLOAK_TOKEN_NAME = "KeycloakToken";
var KEYCLOAK_CLIENT_NAME = "KeycloakClient";
var SSO_PARAMETER_NAME = "accountName";
var KEYCLOAK_REALM_PARAMETER_NAME = "keycloakRealm";
var UNAUTHORIZED_CODE = "1000";
var UNAUTHORIZED_PAGE = "unauthorized";
var TPSheetTabs = {
  IDENTITY: "identity",
  ATTRIBUTES: "attributes",
  PRINCIPALS: "principals",
  BALANCE_SHEET: "balanceSheet",
  RISKS: "risks",
  DATA_HUB: "dataHub",
  ADDITIONAL_DATA: "additionalData"
};
var DocumentTypePropertyType = {
  CHAINE: "CHAINE",
  MULTILIGNES: "MULTILIGNES",
  EMAIL: "EMAIL",
  TELEPHONE: "TELEPHONE",
  IBAN: "IBAN",
  MONTANT: "MONTANT",
  NOMBRE: "NOMBRE",
  DECIMAL: "DECIMAL",
  DEVISE: "DEVISE",
  DATE: "DATE",
  RADIO_BUTTON: "RADIO_BUTTON",
  LIST_ITEM: "LIST_ITEM",
  CASE_A_COCHER: "CASE_A_COCHER",
  LISTE_CHOIX: "LISTE_CHOIX",
  BANK_COUNTRY_CODE: "BANK_COUNTRY_CODE",
  //Not used
  SIGNATURE: "SIGNATURE",
  TEXTAREA: "TEXTAREA",
  QUESTION_TEXTAREA: "QUESTION_TEXTAREA"
};
var CompanyCategory = Object.freeze({
  PME: "PME",
  ETI: "ETI",
  GE: "GE",
  AUT: "AUT",
  NC: "NC"
});
var CollectiveProceedingStatus = Object.freeze({
  NONE: "NEANT",
  CLOSED: "CLOTURÉE",
  IN_BONIS: "CLOTURÉE / IN BONIS",
  OUI: "OUI"
});
var dossiersTypesCodeToIgnore = ["DNB_ESG_REPORT", "ECOVADIS_SCORECARD", "SECURITY_RATING_REPORT"];

/**
 * This method is used for some dossiers like ( Ecovadis and ESG ) to block some actions.
 * - Dossier Type should not be activated/deactivated.
 * - We can only update the name of the dossier type.
 * - Dossiers of this type can't be created manually.
 * - Dossiers of this type can't be archived/reactivated.
 * - Dossiers of this type can't be switched to an other type.
 *
 * @param {*} dossierTypeCode
 */
var isSealedDossier = function isSealedDossier(dossierTypeCode) {
  return dossiersTypesCodeToIgnore.includes(dossierTypeCode);
};
var documentsTypesCodeToIgnore = ["ESG_REPORT", "ECOVADIS_SCORECARD", "SECURITY_RATING_REPORT", "CREDITSAFE_REPORT"];

/**
 * This method is used for some documents like ( Ecovadis and ESG Reports) to block some actions.
 * - The document should not be added / removed as a requirement for dossiers.
 * - The Smart Pilot should not use these documents as criteria.
 *
 * @param {*} documentCode
 */
var isSealedDocument = function isSealedDocument(documentCode) {
  return documentsTypesCodeToIgnore.includes(documentCode);
};
var UserInvitationStatus = {
  REGISTERED: "REGISTERED",
  INVITED: "INVITED",
  EXPIRED_INVITATION: "EXPIRED_INVITATION",
  DECLINED: "DECLINED"
};
var FREE_DOSSIER_TYPE_ID_VALUE = 'null';

// Doit renvoyer la liste complete des langues supportées dans les traductions
var getUserLanguages = function getUserLanguages() {
  return [{
    code: 'fr',
    name: i18next.t("userLanguages.fr")
  }, {
    code: 'en',
    name: i18next.t("userLanguages.en")
  }, {
    code: 'pt',
    name: i18next.t("userLanguages.pt")
  }, {
    code: 'es',
    name: i18next.t("userLanguages.es")
  }, {
    code: 'de',
    name: i18next.t("userLanguages.de")
  }, {
    code: 'nl',
    name: i18next.t("userLanguages.nl")
  }, {
    code: 'it',
    name: i18next.t("userLanguages.it")
  }];
};
var ContextBondTypes = {
  CONTEXT: 'context',
  CONTEXT_THIRD_PARTY: 'context_third_party',
  CONTEXT_THIRD_PARTY_DEMAND: 'context_third_party_demand'
};
var InnerFieldValue = {
  VALUE: 'VALUE',
  LAST_MODIFICATION_DATE: 'LAST_MODIFICATION_DATE'
};

export { AI_EXTRACTED_DATA_KEYS, ATTRIBUTE_MAX_LABEL_LENGTH, ATTRIBUTE_MAX_LIST_VALUE_LENGTH, ATTRIBUTE_MAX_TEXT_VALUE_LENGTH, ATTRIBUTE_VALUES_MIN_SIZE, AcquisitionChannel, ActivityLevel, AttributeType, BANK_DATA_KEYS, CollectiveProceedingStatus, CompanyCategory, ContextBondTypes, DATA_TABLE_ACTIONS, DOMTOMList, DefaultSelectProps, DocumentFormDataType, DocumentTypePropertyType, DossiersAdditionalFieldsNames, EDGE_DATE_FORMAT, ERROR, Exports, FREE, FREE_DOSSIER_TYPE_ID_VALUE, FieldDisplayVariant, FieldType, INDUED, INFO, InnerFieldValue, KEYCLOAK_CLIENT_NAME, KEYCLOAK_REALM_PARAMETER_NAME, KEYCLOAK_TOKEN_NAME, Operator, REGEXP_DECIMAL, REGEXP_DOSSIER_MODEL_CODE, REGEXP_EMAIL, REGEXP_INTEGER, REGEXP_NAME, REGEXP_PASSWORD, REGEXP_PERCENTAGE, REGEXP_SEMICOLON, SEARCH_TYPE_PATTERNS, SIS_ID, SSO_PARAMETER_NAME, SUCCESS, Subscription, SubscriptionsControls, TPSheetTabs, TRUSTPAIR, ThirdpartyAdditionalFieldsNames, ThirdpartyScoreType, ThirdpartyScoresFieldsNames, UNAUTHORIZED_CODE, UNAUTHORIZED_PAGE, UserInvitationStatus, WARNING, documentsTypesCodeToIgnore, dossiersTypesCodeToIgnore, getUserLanguages, isSealedDocument, isSealedDossier, preferredCountries, statusEngCode };
